'use client'
import { I18NText } from '@/components/I18NText'
import { useCurrentUser } from '@/context/CurrentUserContext'
import { useOrg } from '@/context/OrgContext'
import Link from 'next/link'
import { DropdownMenuItem } from '../../ui/dropdown-menu'

export const OrganizationSettingsItem = () => {
	const org = useOrg()
	const currentUser = useCurrentUser()

	if (
		!org ||
		org.is_demo ||
		(!currentUser.admin && org.user_role !== 'OWNER')
	) {
		return null
	}

	return (
		<Link href={`/org/${org.id}/settings`}>
			<DropdownMenuItem>
				<I18NText text="navbar.menu.settings" />
			</DropdownMenuItem>
		</Link>
	)
}
